import { render } from "./AvatarState.vue?vue&type=template&id=38492fcf"
import script from "./AvatarState.vue?vue&type=script&lang=js"
export * from "./AvatarState.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__